// extracted by mini-css-extract-plugin
export default {"mCard":"Pw-z","image":"Qw-z","imageNoBackground":"Rw-z","fullWidth":"Sw-z"};